import { 
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  SvgIcon
} from '@mui/material';
import React, { useContext, useEffect } from 'react';
import { aiAssistantContext } from '../../../state/AIAssistantContextProvider';
import useScreenSize from '../../../utils/useScreenSize';
import { palette } from '../../../assets/styles/themes/tokens';
import getMuiIcon from '../../../utils/getMuiIcon';
import AIAssistantDraggable from './AIAssistantDraggable';

export const DIALOG_WIDTH = {
  SLIM: 375,
  EXTENDED: 900,
};

export const INITIAL_POSITION = {
  top: 126,
  right: 16,
};

const AIAssistantDialog = () => {
  const { isSmallScreen, isMediumScreen, isLargeScreen } = useScreenSize();
  const { isAssistantOpen, toggleAssistant, isExtended, toggleExtended } = useContext(aiAssistantContext);

  useEffect(() => {
    if (isMediumScreen && isExtended) {
      toggleExtended();
    }
  }, [isExtended, toggleExtended, isMediumScreen]);

  return (
    <Dialog
      data-testid='ai-assistant-dialog'
      open={isAssistantOpen}
      onClose={toggleAssistant}
      PaperComponent={isSmallScreen ? Paper : AIAssistantDraggable}
      aria-labelledby='draggable-dialog-title'
      hideBackdrop
      sx={{
        zIndex: 1400,
        pointerEvents: 'none',
        '& .MuiPaper-root': {
          pointerEvents: 'all',
          position: 'absolute',
          top: isSmallScreen ? 0 : INITIAL_POSITION.top,
          right: isSmallScreen ? 0 : INITIAL_POSITION.right,
          margin: 0,
          width:  isSmallScreen ? '100%' : isExtended ? DIALOG_WIDTH.EXTENDED : DIALOG_WIDTH.SLIM,
          height: isMediumScreen ? 816 : '100%',
          maxWidth: DIALOG_WIDTH.EXTENDED,
          maxHeight: isSmallScreen ? '100%' :`calc(100% - ${INITIAL_POSITION.top}px - 16px)`
        }
      }}
    >
      <DialogTitle
        id='draggable-dialog-title'
        data-testid='ai-assistant-dialog-title'
        sx={{ 
          cursor: isLargeScreen ? 'move' : 'initial',
          borderBottomWidth: '1px',
          borderBottomStyle: 'solid',
          borderColor: palette.elevation.outlined,
          justifyContent: 'flex-end',
          display: 'flex' 
        }}>
        {isLargeScreen && (
          <IconButton data-testid='ai-assistant-extend-button' onClick={toggleExtended}>
            <SvgIcon
              sx={{ width: 24, height: 24, color: palette.text.secondary }}
              viewBox='0 0 24 24'
              component={getMuiIcon(isExtended ? 'minimize' : 'maximize')}
            /> 
          </IconButton>
        )}
        <IconButton data-testid='ai-assistant-close-button' onClick={toggleAssistant}>
          <SvgIcon
            sx={{ width: 24, height: 24, color: palette.text.secondary }}
            viewBox='0 0 24 24'
            component={getMuiIcon('close')}
          /> 
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ backgroundColor: palette.common.white }}>
      </DialogContent>
      <DialogActions>
      </DialogActions>
    </Dialog>
  );
};

export default AIAssistantDialog;
